import React from 'react';
import VimeoEmbed from '../../Shared/VimeoEmbed'
import styles from './Testimonials.module.scss';

const Testimonial = (props) => (
  <div id={ props.id } className={styles.Story} style={ props.style }>
    <div className={styles.Story__Wrapper}>

      <div className={`${styles.StoryItem} ${styles.StoryItemTwo}`}>
        <div className={styles.StoryItemTwo__Left}>
          <div>
            <img className="profile-image" src="https://images.ctfassets.net/j91b9gwu8s3q/fAHND4LMGIGa28CEGsY6O/eb10bd5beee2fcae56ea2fe02a13d61c/Julie-e1432081394166.jpg" alt="Julie Lythcott-Haims - Global Citizen Year" />
            <h3>Julie Lythcott-Haims<br/>
            Fmr. Freshman Dean,<br/>
            Stanford University</h3>
          </div>
        </div>
        <div className={styles.StoryItemTwo__Right}>
          <p className="animated">“As a former freshman dean, I can tell you that students who take a little time away doing something productive - where they have the chance to grow a sense of self, greater skills and capacities - those students come to campus better equipped to take greatest advantage of what college has to offer.”</p>
          {
              props.testimonials.videoLink &&
              <VimeoEmbed
                url="https://player.vimeo.com/external/294234462.hd.mp4?s=a11dab57d5b9ea769bcd9d9436465c671df7c25a&profile_id=174&download=1"
                loop={false}
                autoplay={false}
                controls={true}
              />
          }
        </div>
      </div>

    </div>
  </div>
)

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/ForParents/Testimonial/index.js